// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Input Wrapper */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.input-full-width {
  width: 100%;
}

/* Input Label */
.input-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-white);
  display: block;
}

.input-required {
  color: var(--color-error);
  margin-left: var(--space-xs);
}

/* Input Container */
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

/* Input Field */
.input-field {
  width: 100%;
  padding: var(--space-md);
  font-size: var(--font-size-base);
  font-family: var(--font-family);
  color: var(--color-white);
  background: var(--glass-bg);
  border: 2px solid var(--glass-border-strong);
  border-radius: var(--radius-lg);
  transition: all var(--transition-base);
  outline: none;
}

.input-field:focus {
  border-color: var(--color-primary);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.input-field:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--color-dark-light);
}

.input-field::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

/* Input with Icons */
.input-with-left-icon {
  padding-left: calc(var(--space-xl) + var(--space-md));
}

.input-with-right-icon {
  padding-right: calc(var(--space-xl) + var(--space-md));
}

.input-icon {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  pointer-events: none;
}

.input-icon-left {
  left: var(--space-md);
}

.input-icon-right {
  right: var(--space-md);
}

/* Error State */
.input-error {
  border-color: var(--color-error);
}

.input-error:focus {
  border-color: var(--color-error);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2);
}

.input-error-text {
  font-size: var(--font-size-sm);
  color: var(--color-error);
  display: block;
}

/* Hint Text */
.input-hint {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.6);
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Input.css"],"names":[],"mappings":"AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;EAC5C,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;AAChB","sourcesContent":["@import '../../styles/variables.css';\n\n/* Input Wrapper */\n.input-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.input-full-width {\n  width: 100%;\n}\n\n/* Input Label */\n.input-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-white);\n  display: block;\n}\n\n.input-required {\n  color: var(--color-error);\n  margin-left: var(--space-xs);\n}\n\n/* Input Container */\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n/* Input Field */\n.input-field {\n  width: 100%;\n  padding: var(--space-md);\n  font-size: var(--font-size-base);\n  font-family: var(--font-family);\n  color: var(--color-white);\n  background: var(--glass-bg);\n  border: 2px solid var(--glass-border-strong);\n  border-radius: var(--radius-lg);\n  transition: all var(--transition-base);\n  outline: none;\n}\n\n.input-field:focus {\n  border-color: var(--color-primary);\n  background: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.input-field:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: var(--color-dark-light);\n}\n\n.input-field::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Input with Icons */\n.input-with-left-icon {\n  padding-left: calc(var(--space-xl) + var(--space-md));\n}\n\n.input-with-right-icon {\n  padding-right: calc(var(--space-xl) + var(--space-md));\n}\n\n.input-icon {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.6);\n  pointer-events: none;\n}\n\n.input-icon-left {\n  left: var(--space-md);\n}\n\n.input-icon-right {\n  right: var(--space-md);\n}\n\n/* Error State */\n.input-error {\n  border-color: var(--color-error);\n}\n\n.input-error:focus {\n  border-color: var(--color-error);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2);\n}\n\n.input-error-text {\n  font-size: var(--font-size-sm);\n  color: var(--color-error);\n  display: block;\n}\n\n/* Hint Text */\n.input-hint {\n  font-size: var(--font-size-sm);\n  color: rgba(255, 255, 255, 0.6);\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
